import { showModal } from '@/lib/modal';
import type { EventOf } from '@/lib/utils';
import { $1, on } from '@/lib/utils';

on('click', '#areamap a', (ev: EventOf<HTMLAnchorElement>) => {
  showModal($1(ev.currentTarget.getAttribute('href')!)!);
  ev.preventDefault();
});
